
import { IPricingExtremeAdpriceSchemaViewDTO, IPricingExtremeAdpriceSchemaDTO } from "../../coreapi-dto/dirs/pricingExtremeAdpriceSchema";
import { IRequestEventHandler } from "../common";
import { BaseDirRequest } from "./baseDirRequest";

class PricingExtremeAdpriceSchemaRequest extends BaseDirRequest<IPricingExtremeAdpriceSchemaViewDTO, IPricingExtremeAdpriceSchemaDTO> {

    constructor(baseUrl: string, token: string, eventHandler: IRequestEventHandler) {
        super(baseUrl, "PricingExtremeAdpriceSchema", token, eventHandler)
    }
}

export default PricingExtremeAdpriceSchemaRequest